import React from 'react';
import { useTranslation } from 'react-i18next';

const REGISTER_NAMES = ['R0', 'R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'R10', 'R11', 'R12', 'SP', 'LR', 'PC', 'xPSR'];

const RegisterView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('debug.registers')}
      </h3>
      <div className="grid grid-cols-2 gap-1 text-xs font-mono">
        {REGISTER_NAMES.map((name) => (
          <div key={name} className="flex justify-between py-0.5">
            <span className="text-gray-500 dark:text-gray-400">{name}</span>
            <span className="text-gray-300 dark:text-gray-600">--------</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegisterView;
